export enum ActiveItem {
    QuickActions = 1,
    Signature,
    TimeZone,
    PrivacyAndTerms,
    FocusedInbox,
    ConversationView,
    MessageList,
    Account,
    Advertising,
    AutomaticReplies,
    WeekStart,
    SenderImage,
    EventsAndInvites,
    AdvertisingGdprV3,
    SearchHistory,
    Notifications,
    LgpdAdvertising,
}

interface ActiveOptionViewState {
    name: ActiveItem;
    isDirty: boolean;
    isLoading: boolean;
    disableSave?: boolean;
}

export default ActiveOptionViewState;
